import { setupPagination } from './pagination';
import { setupModal }      from './modal';
import { setupInline }     from './inline';

/**
 * ページ内の全 .sab-yt-block を初期化する
 */
export function initBlocks() {
	document.querySelectorAll( '.sab-yt-block' ).forEach( ( block ) => {
		const config = parseConfig( block );
		if ( ! config ) return;

		// デバッグロガーを生成してconfigに付与
		config.log = makeLogger( config );

		const playMode   = block.dataset.playMode   || 'modal';
		const pagination = block.dataset.pagination || 'none';

		config.log( 'INIT', {
			blockId:    config.blockId,
			playMode,
			pagination,
			totalPages: config.totalPages,
			page:       config.page,
			sources:    ( config.attrs?.sources || [] ).map( s => s.id ),
			layout:     config.attrs?.layout,
			perPage:    config.attrs?.perPage,
		} );

		// キャッシュステータスをコンソールに出力（デバッグON時かつcacheStatusが存在する場合）
		if ( config.debug ) {
			logCacheStatus( config );
		}

		if ( pagination === 'numbered' || pagination === 'loadmore' ) {
			setupPagination( block, config );
		}

		if ( playMode === 'modal' ) {
			setupModal( block, config );
		} else if ( playMode === 'inline' ) {
			setupInline( block, config );
		}
	} );
}

function parseConfig( block ) {
	try {
		return JSON.parse( block.dataset.config || '{}' );
	} catch {
		return null;
	}
}

/**
 * キャッシュステータスをコンソールに目立つ形で出力する
 */
function logCacheStatus( config ) {
	const status  = config.cacheStatus;
	const blockId = config.blockId;

	const messages = {
		hit:         { label: '✅ CACHE HIT',          style: 'color:#00a32a;font-weight:bold;font-size:12px;', note: 'キャッシュから表示しています（APIコールなし）' },
		fresh:       { label: '🔄 FRESH FETCH',         style: 'color:#0073aa;font-weight:bold;font-size:12px;', note: 'APIから新規取得してキャッシュを更新しました' },
		stale_quota: { label: '⚠️ STALE (QUOTA)',       style: 'color:#d63638;font-weight:bold;font-size:12px;', note: 'APIクォータ枯渇のため、古いキャッシュから表示しています' },
		stale_error: { label: '⚠️ STALE (API ERROR)',   style: 'color:#d63638;font-weight:bold;font-size:12px;', note: 'APIエラーのため、古いキャッシュから表示しています' },
		stale_lock:  { label: '⚠️ STALE (LOCK WAIT)',   style: 'color:#dba617;font-weight:bold;font-size:12px;', note: '並行リクエストのため、古いキャッシュから表示しています' },
	};

	const info = messages[ status ] || { label: `❓ ${ status }`, style: 'color:#646970;font-weight:bold;font-size:12px;', note: '不明なキャッシュ状態' };

	// 有効期限の情報を整形
	const expiry     = config.cacheExpiry;
	const ttlSetting = expiry?.ttl_setting ?? null;
	const expiresAt  = expiry?.expires_at
		? new Date( expiry.expires_at * 1000 ).toLocaleString( 'ja-JP' )
		: null;

	const expiryLine = expiresAt !== null
		? `設定TTL: ${ ttlSetting }秒 ／ キャッシュ有効期限: ${ expiresAt }`
		: ttlSetting !== null
			? `設定TTL: ${ ttlSetting }秒 ／ キャッシュファイルなし（次回アクセス時に生成）`
			: '有効期限情報なし';

	const now = new Date().toLocaleTimeString( 'ja-JP', { hour: '2-digit', minute: '2-digit', second: '2-digit' } );

	// stale 系は warn、それ以外は通常の log で展開済み表示
	if ( status && status.startsWith( 'stale' ) ) {
		console.group( `%c[SAB YT] ${ blockId } [${ now }] ${ info.label }`, info.style );
		console.warn( '状態: ' + status );
		console.warn( '説明: ' + info.note );
		console.log( expiryLine );
		console.log( 'totalPages:', config.totalPages );
		console.groupEnd();
		console.warn( `[SAB YT] ${ blockId } [${ now }] >>> ${ info.note } <<<` );
	} else {
		console.group( `%c[SAB YT] ${ blockId } [${ now }] ${ info.label }`, info.style );
		console.log( '状態: ' + ( status || '(未取得)' ) );
		console.log( '説明: ' + info.note );
		console.log( expiryLine );
		console.log( 'totalPages:', config.totalPages );
		console.groupEnd();
	}
}

/**
 * デバッグロガーを生成する
 * debug フラグが false の場合は何もしない noop を返す
 */
function makeLogger( config ) {
	if ( ! config.debug ) {
		return () => {};
	}

	const prefix = `%c[SAB YT] ${ config.blockId }`;
	const style  = 'color:#c00;font-weight:bold;';

	return function log( label, data ) {
		const time = new Date().toLocaleTimeString( 'ja-JP', { hour: '2-digit', minute: '2-digit', second: '2-digit' } );
		const tag  = `${ prefix } [${ time }] ${ label }`;
		if ( data !== undefined ) {
			console.groupCollapsed( tag, style );
			console.log( data );
			console.groupEnd();
		} else {
			console.log( tag, style );
		}
	};
}